import { intersection } from 'lodash';

export function isSubsetOf(subArray, superArray) {
  if (!Array.isArray(subArray) || !Array.isArray(superArray)) {
    return false;
  }

  return subArray.length === intersection(subArray, superArray).length;
}
